import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { API_KEY } from '@core/tokens';
import { AuthService } from '@features/auth/auth.service';
import { AuthStore } from '@features/auth/store/auth.store';
import { catchError, Observable, throwError } from 'rxjs';

export const authenticationInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const apiKey = inject(API_KEY);
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  let newReq = req.clone();

  if (authStore.token()) {
    newReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authStore.token()}`),
    });
  } else {
    newReq = req.clone({
      headers: req.headers.set('Authorization', `Api-Key ${apiKey}`),
    });
  }

  return next(newReq).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized) {
        authService.clearToken();
        router.navigate(['/login']);
      }

      return throwError(() => error);
    }),
  );
};
